import React from 'react';
import { makeStyles } from '@material-ui/styles';
import { FaBriefcaseMedical } from 'react-icons/fa';
import actions from 'roles-actions-permissions/actions';
import Grid from '@material-ui/core/Grid';
import CollectionItemHeader from '../layout/CollectionItemHeader';
import getTheme from '../../theme/theme';
import AppButtonMinimal from '../basic/AppButtonMinimal';
import ThematicPackageSearchBar from './thematic-packages/ThematicPackageSearchBar';
import ThematicPackageTable from './thematic-packages/ThematicPackageTable';
import ThematicPackageMisc from './thematic-packages/ThematicPackageMisc';
import PermissionsComponent from '../Wrappers/PermissionsComponent';
import { useItems } from '../../hooks/atoms/items-hook';
import CollectionKeys from '../../hooks/molecules/collection-keys';
import AppLoader from '../basic/AppLoader';
import { useDialog } from '../../dialog-provider-hooks';
import BasicField from '../basic/BasicField';
import { useAlerts } from '../../hooks/alerts-hooks';
import ItemsDropdownButton from './ItemsDropdownButton';

const useStyles = makeStyles((theme) => {
  return {
    root: {
      minWidth: 275,
    },
    bullet: {
      display: 'inline-block',
      margin: theme.spacing(0, 1),
      transform: 'scale(0.8)',
    },
    title: {
      fontSize: 14,
    },
    pos: {
      marginBottom: theme.spacing(1),
    },
    demo: {
      backgroundColor: '#f0f0f0',
      alignItems: 'center',
      marginLeft: '5%',
      marginRight: '5%',
    },
  };
});

const ThematicPackages = () => {
  const classes = useStyles();
  const { openDialog } = useDialog();
  const { alertSuccess } = useAlerts();

  const {
    itemsLoading: thematicPackagesLoading,
    count,
    createItem,
  } = useItems(CollectionKeys.THEMATIC_PACKAGES);

  const handleCreateDialog = () => {
    openDialog({
      title: 'New thematic Package',
      body({ state, setState }) {
        const setProperty = (property, value) => {
          return setState((prevState) => {
            return { ...prevState, [property]: value };
          });
        };
        return (
          <Grid container>
            <Grid item xs={ 12 }>
              <BasicField
                title='Name'
                field={ state.name }
                onChange={ (v) => { return setProperty('name', v); } }
              />
            </Grid>
            <Grid item xs={ 12 }>
              <BasicField
                title='Description'
                field={ state.description }
                onChange={ (v) => { return setProperty('description', v); } }
              />
            </Grid>
            <Grid item xs={ 12 }>
              <ItemsDropdownButton
                onChange={ (v) => {
                  return setProperty('race_id', v);
                } }
                title='Population Group'
                collection='races'
                defaultvalue={ state.race_id }
              />
            </Grid>
            <Grid item xs={ 12 }>
              <ItemsDropdownButton
                onChange={ (v) => {
                  return setProperty('device_id', v);
                } }
                title='Device'
                collection='devices'
                defaultvalue={ state.device_id }
              />
            </Grid>
          </Grid>
        );
      },
      async onSubmit(s) {
        return createItem(s)
          .then(() => {
            alertSuccess('Thematic package was successfully created');
          });
      },
    });
  };

  if (thematicPackagesLoading) {
    return <AppLoader />;
  }

  return (
    <div className={ classes.root }>
      <div style={ { display: 'flex', flexDirection: 'row', alignItems: 'center', marginBottom: getTheme().spacing(2) } }>
        <FaBriefcaseMedical
          style={ { color: getTheme().palette.secondary.dark, marginRight: getTheme().spacing(2) } }
          size={ 36 }
        />
        <CollectionItemHeader
          title='Thematic Packages'
          subtitle={ count !== undefined ? `Entries: ${ count }` : '' }
          actions={ (
            <>
              <ThematicPackageSearchBar />
              <PermissionsComponent permissions={ actions.CREATE_THEMATIC_PACKAGE }>
                <AppButtonMinimal
                  text='Create thematic package'
                  onClick={ () => { return handleCreateDialog(); } }
                />
              </PermissionsComponent>
            </>
          ) }
        />
      </div>
      <ThematicPackageTable />
      <PermissionsComponent permissions={ actions.VIEW_MISCELLANEOUS }>
        <ThematicPackageMisc />
      </PermissionsComponent>
    </div>
  );
};

export default ThematicPackages;
